var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCertified = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 284 284",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.5,238.7c.4.2.9.2,1.3.2s.9,0,1.3-.2c1.7-.7,42.7-16.4,53.6-53.9,0-.4.2-.8.2-1.1v-52.6c0-1-.4-2.1-1.1-2.8-.7-.7-1.7-1.1-2.7-1.1h0c-.9,0-31.7-.2-48.2-19.8-1.5-1.7-4.4-1.7-5.9,0-16.5,19.6-47.3,19.8-48.2,19.8h0c-1,0-2,.4-2.8,1.1-.7.8-1.1,1.8-1.1,2.8v52.6c0,.4,0,.8.2,1.1,10.9,37.5,51.9,53.3,53.6,53.9ZM140.4,139.2c9.1-.6,27-1.8,42.5-17.4,15.5,15.6,33.4,16.8,42.5,17.4v43.9c-12.7,28.8-37,40-42.5,40-8.7,0-29.9-10.2-42.5-40v-43.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.3,193c.9,1,2.1,1.6,3.4,1.6s2.2-.4,3.1-1.3l38.6-37.6c1.9-1.9,2.1-5.2.5-7.4-1.7-2.2-4.6-2.4-6.6-.5l-35.3,34.4-12.3-14.3c-1.8-2.1-4.8-2.1-6.6-.1-1.8,2-1.9,5.3-.1,7.4l15.4,17.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154,128.2c-3.9,0,1.5,6.7,1.5,2.9l-2.9,1.4c0-11.2-2.9,6.4-14.4,6.4h-55.4c-11.4,0-20.8,9.2-20.8,20.4v36.1c0,3.8-3.1,6.8-7,6.8s-7-3-7-6.8v-36.1c0-18.7,15.6-33.9,34.7-33.9h55.5c19.1,0,18.7-5.7,18.7,4.3h-2.9c.1,3.8,3.9-1.4,0-1.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110,109.7c-18.1,0-32.9-14.8-32.9-32.9s14.8-32.9,32.9-32.9,32.9,14.8,32.9,32.9-14.8,32.9-32.9,32.9ZM110,57c-10.9,0-19.8,8.9-19.8,19.8s8.9,19.8,19.8,19.8,19.8-8.9,19.8-19.8-8.9-19.8-19.8-19.8Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCertified, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/certified.f8de244c.svg";
export { ForwardRef as ReactComponent };